import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { PortalSiteEntity } from './portal-site.entity';

export type PortalSiteDomainTlsStatus =
	| 'notApplicable'
	| 'pending'
	| 'issued'
	| 'failed';

// One row per hostname a portal_site answers on. isCustom = 0 is the derived
// workd URL (<alias>-<tenant>.my.workd.com) and does not require a DVP _origin
// row; isCustom = 1 hostnames do, and must reference a verified DVP _domain
// before routing is activated.
@Index('UK_portal_site_domain_hostname', ['hostname'], { unique: true })
@Index('fk_portal_site__id', ['fkPortalSiteId'], {})
@Entity('portal_site_domain')
export class PortalSiteDomainEntity extends BaseEntity {
	@Column('int', { name: 'fk_portal_site__id', unsigned: true })
	public fkPortalSiteId!: number;

	@Column('varchar', { name: 'hostname', length: 150 })
	public hostname!: string;

	@Column('tinyint', {
		name: 'isCustom',
		width: 1,
		default: () => "'0'",
	})
	public isCustom!: boolean;

	// References DVP _domain._id. Not a DB-level FK because the DVP table
	// lives in a separate database; integrity is maintained at the service
	// layer (crm-api -> login -> DVP).
	@Column('int', {
		name: 'fk_domain__id_dvp',
		nullable: true,
		unsigned: true,
	})
	public fkDomainIdDvp!: number | null;

	@Column('enum', {
		name: 'tlsStatus',
		enum: ['notApplicable', 'pending', 'issued', 'failed'],
		default: 'notApplicable',
	})
	public tlsStatus!: PortalSiteDomainTlsStatus;

	@Column('varchar', { name: 'tlsCertArn', nullable: true, length: 256 })
	public tlsCertArn!: string | null;

	@Column('tinyint', {
		name: 'isPrimary',
		width: 1,
		default: () => "'0'",
	})
	public isPrimary!: boolean;

	@Column('tinyint', {
		name: 'isActive',
		width: 1,
		default: () => "'1'",
	})
	public isActive!: boolean;

	@ManyToOne(
		() => PortalSiteEntity,
		(portalSite) => portalSite.portalSiteDomains,
		{
			onDelete: 'CASCADE',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: 'fk_portal_site__id', referencedColumnName: 'id' }])
	public fkPortalSite!: PortalSiteEntity;
}
